<template>
  <div class="responsive-iframe" v-html="embed_url">
  </div>
</template>

<script>
export default {
  name: "PowerBiPanel",
  props: {
    embed_url: {
      default: "",
    },
  },
};
</script>

<style>
.responsive-iframe iframe{
  width: 100% !important;
  height: 100%!important;
}
.responsive-iframe {
  width: auto!important;
  height: 100%!important;
  margin-bottom: 0!important;
}
/* xl */
@media only screen and (min-width: 1025px) {
  .responsive-iframe iframe{
    min-height:90vh !important;
    height: 100%!important;
    width: 100%!important;
  }
}
@media only screen and (min-width: 1025px ) and (max-width: 1200px ){
  .responsive-iframe iframe{
    min-height:600px !important;
    height: 100%!important;
  }
}


/* lg */
@media only screen and (max-width: 1024px) {
  .responsive-iframe iframe{
    min-height:500px !important;
    height : 100%!important;
    width: 100%!important;
  }
}
/* md */
@media only screen and (max-width: 768px) {
  .responsive-iframe iframe{
    min-height:350px !important;
    height : 100%!important;
    width: 100%!important;
  }
}
/* sm */
@media only screen and (max-width: 512px) {
  .responsive-iframe iframe{
    min-height:300px !important;
    height : 100%!important;
    width: 100%!important;
  }
}
/* xs */
@media only screen and (max-width: 414px) {
  .responsive-iframe iframe{
    min-height: 30vh!important;
    height : 100%!important;
    width: 100%!important;
  }
}
</style>
